import { type KnoxDeviceListResult } from '@/models/knox/KnoxDevice';
import { HttpError, getJwt } from '../common';

const BASE_URL = import.meta.env.VITE_API_URL;

// Knox Asset Intelligence device health, brand-scoped (PortalAPI guards brand ownership).
export const knoxApi = {
    listDevices: async (
        brandId: string,
        filters?: { statuses?: string[]; batterySohs?: string[] }
    ): Promise<KnoxDeviceListResult> => {
        const params = new URLSearchParams();
        params.set('brandId', brandId);
        filters?.statuses?.forEach((s) => params.append('status', s));
        filters?.batterySohs?.forEach((b) => params.append('batterySoh', b));

        const response = await fetch(`${BASE_URL}/knox/devices?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${getJwt()}`
            }
        });

        const data = await response.json().catch(() => null);
        if (!response.ok) throw new HttpError(response.status, data);
        return data ?? { totalCount: 0, devices: [] };
    }
};
